import { getInsightsGoals } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const useInsightsGoals = () => {
  const today = useToday();
  const user = useUser();
  const sortedGoals = useSortedGoals();

  return useMemo(
    () =>
      getInsightsGoals({
        goals: sortedGoals,
        today,
        insightsSettings: user?.settings?.insights,
      }),
    [sortedGoals, today, user?.settings?.insights],
  );
};
